import { render, staticRenderFns } from "./RouteTimeline.vue?vue&type=template&id=396820ed&"
import script from "./RouteTimeline.vue?vue&type=script&lang=ts&"
export * from "./RouteTimeline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports